import { BASE_URL } from '../components/AppConfig';
import { getBearerToken } from '../utils/authToken';

const authFetch = async (path, options = {}) => {
  const token = getBearerToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });
    return res.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isSuperOverPromotionsApiSuccess = (res) => {
  const code = String(res?.statusCode || res?.status_code || '');
  return code === '10000' || code === '';
};

export const getSuperOverPromotionsPayload = (res) => res?.data ?? null;

/** GET /admin/arcade/super-over-promotions */
export const listSuperOverPromotions = ({ status = 'all', limit = 50, offset = 0 } = {}) => {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  return authFetch(`/admin/arcade/super-over-promotions?${params.toString()}`, { method: 'GET' });
};

/** GET /admin/arcade/super-over-promotions/preview */
export const previewSuperOverPromotions = (at) => {
  const params = new URLSearchParams();
  if (at) params.set('at', at);
  return authFetch(`/admin/arcade/super-over-promotions/preview?${params.toString()}`, { method: 'GET' });
};

/** GET /admin/arcade/super-over-promotions/:id */
export const getSuperOverPromotion = (id) =>
  authFetch(`/admin/arcade/super-over-promotions/${id}`, { method: 'GET' });

/** POST /admin/arcade/super-over-promotions */
export const createSuperOverPromotion = (body) =>
  authFetch('/admin/arcade/super-over-promotions', {
    method: 'POST',
    body: JSON.stringify(body),
  });

/** PATCH /admin/arcade/super-over-promotions/:id */
export const patchSuperOverPromotion = (id, body) =>
  authFetch(`/admin/arcade/super-over-promotions/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

/** DELETE /admin/arcade/super-over-promotions/:id */
export const deleteSuperOverPromotion = (id) =>
  authFetch(`/admin/arcade/super-over-promotions/${id}`, { method: 'DELETE' });
